// extracted by mini-css-extract-plugin
export default {"about":"about_about__s8AVK","about_img":"about_about_img__3NJA3","isVisible":"about_isVisible__hRfng"};